"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _localization = require("../../toolkit/localization");

/*
 *  component/form/Switch.tsx
 *  Project-Lego
 *
 *  Created by Sola Ogunsakin on 12/14/18.
 *  Copyright © 2018-present ContextLogic Inc. All rights reserved.
 */

/* Lego Toolkit */
var DEFAULT_HEIGHT = 23;
var propDoc = {
  isOn: {
    required: true,
    type: "boolean",
    description: "Indicates that the switch is on"
  },
  disabled: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Indicates that the switch is disabled"
  },
  height: {
    required: false,
    type: "number",
    defaultValue: "".concat(DEFAULT_HEIGHT),
    description: "Height of the switch"
  },
  onToggle: {
    required: true,
    type: "(isOn: boolean) => mixed",
    description: "Callback for when the switch is toggled. " + "First parameter is the new state"
  },
  showText: {
    required: false,
    type: "boolean",
    defaultValue: "true",
    description: "Show \"On\" and \"Off\" text beside the switch"
  }
};
var discussion = "\n  Switch can also be rendered with custom children or text\n\n  e.g:\n  ```\n  <Switch isOn={true} onToggle={() => {}}>\n    <div>\n      Custom content\n    </div>\n  </Switch>\n  ```\n";
var demoProps = [{
  demoDescription: "on",
  onToggle: function onToggle() {},
  isOn: true
}, {
  demoDescription: "off",
  onToggle: function onToggle() {},
  isOn: false
}, {
  demoDescription: "disabled",
  isOn: true,
  onToggle: function onToggle() {},
  disabled: true
}];

var Switch = function Switch(props) {
  var styles = useStylesheet(props);

  var _useLocalization = (0, _localization.useLocalization)(),
      i18n = _useLocalization.i18n;

  var children = props.children,
      isOn = props.isOn,
      _props$showText = props.showText,
      showText = _props$showText === void 0 ? true : _props$showText,
      onToggle = props.onToggle,
      disabled = props.disabled,
      className = props.className,
      style = props.style;
  var text = null;

  if (typeof children === "string") {
    text = children;
  } else if (showText && _react["default"].Children.count(children) === 0) {
    text = isOn ? i18n("On") : i18n("Off");
  }

  var textNode = null;

  if (text != null) {
    textNode = /*#__PURE__*/_react["default"].createElement("section", {
      className: (0, _styling.css)(styles.text)
    }, text);
  } else {
    textNode = children;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.knobContainer),
    onClick: function onClick() {
      if (!disabled) {
        onToggle(!isOn);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.spacer)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.knob)
  })), textNode);
};

Switch.propDoc = propDoc;
Switch.demoProps = demoProps;
Switch.discussion = discussion;

var _default = (0, _mobxReact.observer)(Switch);

exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref) {
  var isOn = _ref.isOn,
      disabled = _ref.disabled,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? DEFAULT_HEIGHT : _ref$height,
      colorProp = _ref.color;

  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      primary = _useTheming$theme.primary,
      info = _useTheming$theme.info,
      surfaceLightest = _useTheming$theme.surfaceLightest,
      textBlack = _useTheming$theme.textBlack,
      fonts = _useTheming.fonts;

  var color = colorProp || primary;
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        opacity: disabled ? 0.5 : 1
      },
      spacer: {
        flex: isOn ? 1 : 0,
        opacity: 0,
        transition: "flex 200ms"
      },
      knobContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "0px 2px",
        cursor: disabled ? "default" : "pointer",
        transition: "background-color 600ms linear",
        backgroundColor: isOn ? color : info,
        height: height,
        borderRadius: height,
        minWidth: 35
      },
      knob: {
        display: "flex",
        height: 0.8 * height,
        width: 0.8 * height,
        borderRadius: "100%",
        backgroundColor: surfaceLightest
      },
      text: {
        fontSize: 14,
        fontFamily: fonts.regular,
        color: textBlack,
        cursor: "default",
        userSelect: "none",
        marginLeft: 5
      }
    });
  }, [isOn, disabled, height, color, info, textBlack, surfaceLightest, fonts.regular]);
};